// Dateien für das Gespräch und das Abwägen. Herausgelöst aus
// VerhandlungsPassus.jsx und AbwaegenStudio.jsx (23.09.2026), damit Desktop
// und Handy dieselben Dateitypen annehmen und dasselbe schicken.
//
// Dateien werden nie gespeichert, nur ihr Text (AGENTS.md): Der Server liest
// sie aus, hängt den Text als Beitrag an und verwirft die Datei.

// PDF, Bilder (die KI schreibt sie ab), Text und Mails.
export const DATEI_ANNAHME = '.pdf,.png,.jpg,.jpeg,.webp,.gif,.txt,.md,.csv,.json,.eml,.log,.html,text/*,application/pdf,image/png,image/jpeg,image/webp,image/gif';

/** Der Base64-Teil einer Data-URL ("data:…;base64,XXXX" → "XXXX"). */
export function inhaltAusDataUrl(roh) {
  const text = String(roh || '');
  return text.includes(',') ? text.slice(text.indexOf(',') + 1) : text;
}

/**
 * Nutzlast für op "datei".
 * @param {{ name: string, type: string }} datei  die gewählte Datei
 * @param {string} roh  Ergebnis von FileReader.readAsDataURL
 * @param {'gespraech'|'abwaegung'} ziel  in welchen Verlauf der Text gehört
 */
export function dateiNutzlast(datei, roh, ziel) {
  return {
    op: 'datei',
    dateiname: datei.name,
    dateityp: datei.type,
    inhalt: inhaltAusDataUrl(roh),
    ziel,
  };
}

/** "„a.pdf" gelesen (1.234 Zeichen, 3 Seiten, gekürzt)." - die Antwort auf op "datei". */
export function dateiGelesenText(d) {
  return `„${d.dateiname}" gelesen (${d.zeichen.toLocaleString('de-DE')} Zeichen`
    + `${d.seiten ? `, ${d.seiten} Seiten` : ''}${d.gekuerzt ? ', gekürzt' : ''}).`;
}
